import { render } from "./ProductList.vue?vue&type=template&id=5c197339"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=5c197339&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__